<template>
  <div class="wrap">
    <h3 class="title">隐私政策</h3>
    <p>本政策适用于北京海科融通支付服务有限公司和我是队长app（以下简称“海科融通”或“我们”）平台提供的银行卡收单产品和服务。 <span class="weight">为了遵守国家法律法规及监管规定（包括但不限于：履行反洗钱管理职责、履行国家金融安全管理职责、进行实名制管理），为了确保您选择的产品的基本功能实现，也为了向您提供新的服务及提升服务质量（例如：支持我们设计新服务或完善已有服务功能，为您提供和推荐更为优质或完善的服务），在您使用我们提供的产品和服务时，我们将按照本《隐私政策》收集、存储、使用、加工、传输、提供、公开、删除、保护等处理您的个人信息。同时，我们会通过本《隐私政策》向您说明，我们如何为您提供访问、更新、管理和保护您的个人信息服务。</span></p>
    <p>生效日期：2021年11月15日</p>
    <p class="weight">本政策将帮助您了解以下内容：</p>
    <p class="weight">1、我们如何收集和使用您的个人信息；</p>
    <p class="weight">2、我们如何使用 Cookie 、Beacon、Proxy等同类技术；</p>
    <p class="weight">3、我们如何共享、转让、公开披露、委托处理您的个人信息；</p>
    <p class="weight">4、我们如何保护和保存您的个人信息；</p>
    <p class="weight">5、您的权利；</p>
    <p class="weight">6、我们如何处理未成年人的个人信息；</p>
    <p class="weight">7、您的个人信息如何在全球范围转移；</p>
    <p class="weight">8、本政策如何更新；</p>
    <p class="weight">9、如何联系我们。</p>
    <p>海科融通深知个人信息对您的重要性，也感谢您对海科融通的信任，我们会竭尽全力保护您的个人信息安全可靠。</p>
    <p>本隐私政策提及的个人信息仅针对操作用户账户的自然人之信息以及机构服务商的信息中涉及的个人信息部分。</p>
    <p>基于平台使用的特殊性，您授权的自然人主体使用本平台的行为视为您的行为，您应该为此承担相应的责任。</p>
    <p>我们致力于维持您对我们的信任，恪守以下原则，保护您的信息:权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，海科融通承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的信息。</p>
    <p class="weight">请在使用我们的产品(或服务)前，仔细阅读并了解本《隐私政策》。</p>
    <p class="weight">一、我们如何收集和使用您的信息</p>
    <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 </p>
    <p class="weight">敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>
    <p>我们仅会出于本政策所述的以下目的，收集和使用您的企业信息及个人信息:</p>
    <p class="weight">（一）我们如何收集您的信息</p>
    <p>在您使用平台服务的过程中，在以下情形中我们需要收集您的一些信息，用以向您提供服务、提升我们的服务质量、保障您的账户和资金安全以及符合国家法律法规及监管规定：</p>
    <p class="weight">1、用户注册：您进行平台用户注册时，需提供手机号码、验证码进行用户注册。</p>
    <p class="weight">2、向您提供服务</p>
    <p class="weight">（1）开通服务：为了保证您正常拓展特约商户，我们在为您开通服务功能前，需要获取您的GPS定位信息、手机相机使用权限、相册/外部存储读写权限；以及收集您的1）信息，包括手机号码、身份证号及正反面照片、邮箱（非必填）、企业委托人（可选）姓名、身份证号及身份证正反面照片、企业委托授权书、；2）收款入账银行账户信息，包括开户行、户名、账号；3）经营信息，包括名称、店铺地址、门头照或经营场所照片（非必填）。</p>
    <p class="weight">（2）升级服务：您可以通过提交更多认证资料提升您的管理等级，1）银行卡认证信息，包括您的银行卡开户行、账户名、卡号、银行预留手机号码；2）营业执照认证信息，包括您成为外包服务商时使用的经营店铺名称、统一社会信用代码、营业执照照片。</p>
    <p class="weight">（3）提款服务：您使用平台提款服务时，需要开通服务功能，对您开通过程中提交的基本信息、银行卡信息进行再次验证。</p>
    <p>（4）交易查询：为了向您提供日常交易、资金管理服务，方便您实时查看交易信息与经营数据，我们记录并向您展示您的交易流水及划款入账信息。</p>
    <p>（5）在线客服：为了更好的达成我们向您提供的服务，我们向您提供在线客服服务，您使用时我们需要获取您的相机使用权限、外部读写存储权限，方便您更好的与我们交流。</p>
    <p>（6）增值业务：我们在为您提供的其他金融类增值业务过程中，我们会在您明确授权的情况下向您提供相应的服务，如信用卡申办业务等。其中，<span class="weight">信用卡申办业务我们会在您授权同意的情况下，将您提供给平台的与申办信用卡有关的必要信息提供给发卡行。</span></p>
    <p>（7）个性化推送服务：为提升您的服务体验及改进服务质量，我们可能会根据您的授权提供个性化推送业务。<span class="weight">推送业务可能需要获取并使用您的个人信息、设备信息及其他必要信息。</span>例如，您可以选择提供您的地理位置信息，以便您基于所在地点位置接受个性化服务推荐；如您不提供前述信息，您将不会收到该等个性化服务推荐，但不影响您使用我们提供的其他服务。<span class="weight">如果您不想接收我们发送的营销信息，您可以通过短信回复或拨打我们的服务电话取消个性化推送业务。</span></p>
    <p>（8）其他业务：我们将会不断更新产品和服务，基于您申办我们提供的其他业务，我们将会根据业务需要使用您的信息，我们会另行向您说明信息收集的范围和目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您将无法使用某部分服务，但不影响您使用我们提供的其他服务。</p>
    <p class="weight">3、安全管理</p>
    <p class="weight">为了保障向您提供的服务的安全稳定运行，预防交易和资金风险，我们需要记录您使用的服务类别、方式及相关操作信息，例如：所属运营商、设备硬件信息、设备型号、IP地址、设备软件版本信息、设备识别码、设备标识符、所在地区、网络使用习惯以及其他与平台服务相关的日志信息。如您不同意我们记录前述信息，可能无法完成风控验证。</p>
    <p class="weight">4、根据相关法律法规及国家标准，在以下情形中，我们可能会依法收集并使用您的信息无需征得您的同意:</p>
    <p class="weight">（1）法律、行政法规规定应当保密或者不需要告知的情形；</p>
    <p class="weight">（2）与个人信息控制者履行法律法规规定的义务相关的；</p>
    <p class="weight">（3）与国家安全、国防安全直接相关的；</p>
    <p class="weight">（4）与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p class="weight">（5）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
    <p class="weight">（6）出于维护您或他人生命、财产等重大合法权益但又无法及时得到您本人同意的；</p>
    <p class="weight">（7）所收集的个人信息是您自行向社会公众公开的；</p>
    <p class="weight">（8）根据您的要求签订和履行合同所必需的；</p>
    <p class="weight">（9）从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；</p>
    <p class="weight">（10）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置服务的故障；</p>
    <p class="weight">（11）法律法规规定的其他情形。</p>
    <p>5、其他</p>
    <p>如您选择使用我们提供的其他服务，基于该服务我们需要收集您的信息的，我们会另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。</p>
    <p class="weight">（二）我们从第三方获得您信息的情形</p>
    <p>1、我们可能从第三方获取您授权共享的账户信息，并在您同意本隐私政策后通过第三方账户直接登录并使用我们的产品与/或服务，这些第三方包括平台关联方等。在符合相关法律和法规规定的前提下，使用您的这些信息。</p>
    <p>2、在取得您同意的前提下，我们可能从合法持有您信息的第三方机构获得您的信息，如技术、咨询服务供应商、金融机构等，这些合作机构会提供与我们服务相关的产品和服务，帮助检测和防止潜在的违法犯罪行为和违反我们政策的行为。</p>
    <p class="weight">（三）我们如何使用您的信息</p>
    <p>我们收集您信息的目的主要是为了向您提供安全、高效以及个性化的服务体验。我们会出于以下目的使用您的信息：</p>
    <p class="weight">1、进行身份证件认证、人脸识别、手机运营商认证、银行卡认证、工商认证、资格审核</p>
    <p><span class="weight">为遵守实名制管理规定（反洗钱/反欺诈）和运用您提交的主体信息核实主体资格的需要，您同意并授权我们处理您的相关信息，包括但不限于：企业名称、统一社会信用代码、企业银行账户名称、账号、开户行、法定代表人姓名、身份证号及身份证身份证有效期（开始时间-截止时间）、委托人姓名、身份证号及身份证有效期（开始时间-截止时间）、人脸照片、手机号码。</span>我们会将上述信息以加密传输方式提交给合法的第三方身份验证机构，以便对您所提供信息的准确性进行核对。如果您不提供上述信息则无法使用平台展业相关的服务，且根据中国相关法律法规必须进行实名制管理的相关金融服务以及平台服务。</p>
    <p class="weight">认证您的身份时，平台可能需要启动人脸识别功能（即面部识别特征），从而校验操作者是否为您本人或您授权的主体。此功能的实现平台将委托合法第三方进行验证，原则上平台并不存储原始个人生物识别信息，可采取的措施包括但不限于：</p>
    <p class="weight">1) 仅存储个人生物识别信息的摘要信息；</p>
    <p class="weight">2) 在采集终端中直接使用个人生物识别信息实现身份识别、认证等功能；</p>
    <p class="weight">3) 在使用面部识别特征、指纹、掌纹、虹膜等实现识别身份、认证等功能后删除可提取个人生物识别信息的原始图像。</p>
    <p class="weight">2、进行资格、信用的审核</p>
    <p><span class="weight">您在使用我们服务时，我们会使用您的基本信息、身份信息及其他在具体业务开展过程中基于您的同意而采集的信息进行风险管理及控制，检测、预防及/或修复欺诈或其他潜在的非法活动。</span>如果您不提供上述信息，我们则无法在您使用服务过程中对您的身份、信用进行评估并决定是否提供您所需的服务，但不影响您使用我们提供的其他服务。</p>
    <p class="weight">3、为您提供您选择的相关服务</p>
    <p><span class="weight">您在使用我们平台上的服务时，我们会使用您的身份信息及其他在业务具体开展过程中基于您的同意而采集的信息对产品或服务进行适用性评估、验证服务真实性、处理产品或服务请求以及完成服务指令并向您发送服务通知等。</span>同时，为了遵守相关法律法规及监管规定，也为了便于您查询服务记录或历史状态，我们会将您使用的身份信息、服务信息及行为信息进行存档，并严格按照法律法规的规定对这些信息进行妥善保管。上述信息为开展我们服务所必需的信息，如果您不提供上述信息，将可能导致我们无法为您提供上述服务。</p>
    <p class="weight">4、提供客户服务及进行投诉处理</p>
    <p><span class="weight">我们的在线客服会使用您的账号信息和服务信息。为保证您的账号安全，我们的在线客服会使用您的账号信息与您核验您的身份。</span>当您需要我们提供与您服务信息相关的客服与售后服务时，我们将会查询您的服务信息。</p>
    <p>为了保证您及他人的合法权益，如您被他人投诉或投诉他人，在必要时，我们会将您的相关信息、投诉相关内容提供给消费者权益保护部门及监管机关，以便及时解决投诉纠纷，但法律法规明确禁止提供的除外。</p>
    <p class="weight">5、改进我们的产品以为您提供更为个性化的服务</p>
    <p>（1）我们会在采取脱敏、去标识化等方式对您的信息进行处理后再进行综合统计、分析加工，以便为您提供更加准确、个性、流畅及便捷的服务，或帮助我们评估、改善或设计服务及运营活动等；</p>
    <p class="weight">（2）为了提升您的服务体验，为您推荐更为优质或适合的服务，我们可能会根据您的信息形成特征标签，用于向您提供您可能感兴趣的营销活动通知、商业性电子信息或广告，如您不希望接收此类信息，您可按照我们提示的方法选择退订，例如回复“TD”退订营销短信。</p>
    <p>当我们要将信息用于本政策未载明的其他用途时，会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认动作等形式再次征得您的同意。</p>
    <p class="weight">6、网签协议签约与存证服务</p>
    <p class="weight">您授权本平台委托第三方进行网签协议的签署，并由第三方进行网签协议的存证工作。签署过程中将使用您的名称、统一社会信用代码、签约人姓名、签约人身份证号码、签约人手机号码等信息，并将前述信息提供给第三方。</p>
    <p class="weight">您认可电子签章记载时间为网签协议签署时间，且认可经过电子签章的网签协议的完全效力，不得以非纸质协议或协议可被篡改等为理由否认其效力。</p>
    <p class="weight">7、保障服务安全所必须的功能</p>
    <p class="weight">为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的浏览信息、服务信息、您常用的软件信息、设备信息等手段来判断您的账号风险，并可能会记录一些我们认为有风险的链接；我们也会收集您的设备信息对于我们系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。</p>
    <p class="weight">8、敏感个人信息的处理</p>
    <p class="weight">平台将会按照法律规定处理您的敏感个人信息，包括生物识别信息、账户信息、交易信息、交易地点。该敏感个人信息的处理为您使用平台服务之必须。在您使用平台服务的过程中，针对敏感个人信息的正常处理不会对您的合法权益产生不良影响。</p>
    <p class="weight">（四）您信息使用的规则</p>
    <p>1、我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能、履行协议、提供服务、解决争议、保障交易安全等目的对您所提供的以及我们收集的信息进行使用。</p>
    <p>2、请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。您注销账号请求处理完成一个月之后，我们将停止您使用该账号的权限并按照相关法律法规的要求删除您的个人信息或进行匿名化处理，法律法规、行业规定保留的除外。</p>
    <p>3、当我们展示您的信息时，我们会根据国家规定采用去标识化、匿名化等技术处理方式对您的信息进行脱敏，以保护您的信息安全。</p>
    <p>4、当我们要将您的信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
    <p class="weight">二、我们如何使用 Cookie和Beacon、Proxy等同类技术</p>
    <p class="weight">(一)Cookie </p>
    <p>为使您获得更轻松的访问体验，您使用平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做可帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全状态。<span class="weight">这些数据文件可能是Cookie、Flash Cookie，您的浏览器或关联应用程序提供的其他本地存储（以下简称“Cookie”）。</span>同时，为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。<span class="weight">借助于Cookie，网站能够存储您的偏好或购物篮内的商品等数据。</span></p>
    <p>我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</p>
    <p class="weight">（二）Beacon</p>
    <p class="weight">我们网站上还可能包含一些电子图像（以下简称“网络Beacon”），使用网络Beacon可以帮助网站计算浏览网页的用户或访问某些Cookie，我们会通过网络Beacon收集您浏览网页活动的信息，例如：您访问的页面地址、您先前访问的援引页面的位置、您的浏览环境以及显示设定。</p>
    <p class="weight">（三）Proxy</p>
    <p><span class="weight">如您通过我们的网站或APP，使用了由第三方而非平台提供的服务时，为尽力确保您的账号安全，使您获得更安全的访问体验，我们可能会使用专用的网络协议及代理技术（以下简称“Proxy技术”）。</span>使用Proxy技术，可以帮助您识别到我们已知的高风险站点，减少由此引起的钓鱼、账号泄露等风险，同时更有利于保障您和第三方的共同权益，阻止不法分子篡改您和您希望访问的第三方之间正常服务内容，例如：不安全路由器、非法基站等引起的广告注入、非法内容篡改等。<span class="weight">在此过程中，我们也可能会获得和保存关于您计算机的相关信息，例如：IP地址、硬件ID。</span></p>
    <p class="weight">（四）网站信标和像素标签</p>
    <p><span class="weight">我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。</span>网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。<span class="weight">如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</span></p>
    <p class="weight">（五）Do Not Track(请勿追踪)</p>
    <p>很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了 Do Not Track，那么我们的所有网站都会尊重您的选择。</p>
    <p class="weight">三、我们如何共享、转让、公开披露您的信息</p>
    <p class="weight">(一)共享</p>
    <p>我们不会与海科融通以外的任何公司、组织和个人分享您的信息，但以下情况除外: </p>
    <p>1、在获取明确同意的情况下共享:获得您的明确同意后，我们会与其他方共享您的信息。</p>
    <p class="weight">2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的信息。 </p>
    <p>3、与我们的附属公司共享:为您提供服务之必须或更好地为您提供服务，您的信息可能会与海科融通的附属公司共享。我们只会共享必要的信息，且受本隐私政策中所声明目的的约束。附属公司如要改变信息的处理目的，将再次征求您的授权同意。</p>
    <p>4、第三方共享登录</p>
    <p>我们会将您的登录信息如USERID、登录名等共享给海科融通其他平台以便您可以使用同一账号登录多个平台。但我们只会共享必要的信息，且受本隐私政策中所声明目的的约束。</p>
    <p>5、与授权合作伙伴共享:仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些信息，以提供更好的客户服务和用户体验。例如，在您提取银行卡受理终端时，我们必须与物流服务提供商共享您的收货信息才能安排送货。我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息，并且只会共享提供服务所必要的信息。我们的合作伙伴无权将共享的信息用于任何其他用途。 </p>
    <p>目前，我们的授权合作伙伴包括以下类型: </p>
    <p>（1）提供技术、咨询服务的供应商。我们可能会将您的信息共享给支持我们提供服务的第三方。这些机构包括为我们提供基础设施技术服务、数据处理服务、电信服务、审计服务和法律服务等的机构。但我们要求这些服务提供商只能出于为我们提供服务的目的使用您的信息，而不得出于其自身利益使用您的信息。</p>
    <p>（2）合作的金融机构及保险机构，这些机构可能向我们提供金融服务产品。除非您同意将这些信息用于其他用途，否则这些金融机构不得将此类信息用于相关产品之外的其他目的。</p>
    <p class="weight">（3）第三方SDK服务机构（提供辅助服务软件开发工具包的第三方）。为了向您提供更好的服务，我们接入了第三方SDK服务，并将您的部分信息提供给第三方服务机构，具体如下：</p>
    <table border="1" style="margin: 10px 0;">
        <tr>
            <th>SDK名称</th>
            <th>场景描述（使用目的）</th>
            <th>涉及收集的个人信息字段</th>
            <th>数据接收方名称</th>
        </tr>
        <tr>
            <td>证卡识别SDK</td>
            <td>身份证和银行卡识别功能</td>
            <td>银行卡、身份证信息</td>
            <td>北京译图智讯科技有限公司</td>
        </tr>
        <tr>
            <td>旷视人脸识别SDK</td>
            <td>人脸识别服务</td>
            <td>人脸信息</td>
            <td>北京旷视科技有限公司</td>
        </tr>
        <tr>
            <td>高德定位SDK</td>
            <td>定位功能</td>
            <td>经纬度信息</td>
            <td>高德软件有限公司</td>
        </tr>
        <tr>
            <td>腾讯定位SDK</td>
            <td>定位功能</td>
            <td>经纬度信息</td>
            <td>腾讯科技有限公司</td>
        </tr>
        <tr>
            <td>终端SDK</td>
            <td>刷卡功能</td>
            <td>终端、银行卡信息</td>
            <td>
              <p>武汉天喻信息产业股份有限公司</p>
              <p>上海动联信息技术股份有限公司</p>
              <p>福建魔方电子科技有限公司</p>
            </td>
        </tr>
        <tr>
            <td>神策埋点SDK</td>
            <td>用户点击按钮页面收集功能</td>
            <td>app内页面、按钮信息</td>
            <td>神策网络科技（北京）有限公司</td>
        </tr>
        <tr>
            <td>个推SDK</td>
            <td>APP推送服务</td>
            <td>手机终端唯一标志信息、商户号信息</td>
            <td>每日互动股份有限公司</td>
        </tr>
        <tr>
            <td>骏聿人脸识别SDK</td>
            <td>人脸识别服务</td>
            <td>人脸信息</td>
            <td>上海骏聿数码科技有限公司</td>
        </tr>
        <tr>
            <td>NFC SDK</td>
            <td>身份证识别功能</td>
            <td>身份证信息</td>
            <td>金联汇通信息科技有限公司</td>
        </tr>
        <tr>
            <td>Tinker SDK</td>
            <td>修复app</td>
            <td>手机终端唯一标志信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
        </tr>
        <tr>
            <td>Bugly SDK</td>
            <td>app升级服务</td>
            <td>手机终端唯一标志信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
        </tr>
    </table>
    <p class="weight">上述相关第三方服务商收集前述信息发生信息泄露的，由相关第三方服务商承担相应的法律责任，我们会对第三方进行法律要求的严格的安全检测并要求第三方提供数据保护措施。</p>
    <p>（4）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息(指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份)与提供广告、分析服务的合作伙伴分享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。例如，只有在广告主同意遵守我们的广告发布准则后，我们才可能会告诉广告主他们广告的效果如何，或者有多少人看了他们广告或在看到广告后安装了应用，或者向这些合作伙伴提供不能识别个人身份的人口统计信息(例如“餐饮类微型企业，关注小贷信息”“位于北京的25岁男性，喜欢软件开发”)，帮助他们了解其受众或顾客。</p>
    <p>（5）供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。 </p>
    <p>（6）以下情形中，您可选择是否授权我们收集、使用您的个人信息。如您拒绝授权部分功能或服务所需信息，您将无法使用相关功能或服务，但这不影响您正常使用我们平台的其他功能或服务：</p>
    <p>①设备状态，用于确定设备识别码，以保证账号登录的安全性。拒绝授权后，我们平台将不读取设备状态，同时可能需要通过其他方式进行账号登录的安全验证；</p>
    <p>②存储权限，用于缓存您在使用海科融通平台过程中产生的文本、图像。如您拒绝授权后，上述功能可能无法正常使用；</p>
    <p>③摄像头，用于身份证识别、银行卡识别、识别二维码、人脸识别、拍照，在扫一扫、人脸识别、中使用。拒绝授权后，上述功能将无法使用；</p>
    <p>④相册，用于上传照片身份证、银行卡、人脸识别功能。获得的图片信息，加密后存储于数据库中。拒绝授权后，上述功能将无法使用；</p>
    <p>⑤手机短信，用于接收短信验证码。如您拒绝通讯信息（短信）授权，将不读取短信内容，则您无法享受上述服务；</p>
    <p>⑥地理位置，获取您所在地理位置，主要用于展现城市服务。系统后台保存您交易时的位置信息。拒绝授权后，上述功能可能无法正常使用；</p>
    <p>⑦网络通讯，用于与服务端进行通讯。拒绝授权后，所有功能无法使用；</p>
    <p>⑧蓝牙，用于通过蓝牙将客户手机与第三方设备连接并交互。拒绝授权后，无法通过蓝牙激活第三方设备；</p>
    <p>⑨剪切板，用于招口令商户编号快速复制功能，系统后台不保存您的剪切板内容。如您拒绝授权剪切板权限，将不读取剪切板内容，则您无法使用上述功能；</p>
    <p>⑩NFC，用于识别身份证使用。如您拒绝授权NFC权限，将无法使用识别身份证功能。</p>
    <p>上述功能可能需要您在您的设备中向我行开启您的设备、存储、相机（摄像头）、相册、地理位置（位置信息）、手机通讯录、短信、麦克风、网络通讯、蓝牙、应用列表、日历的访问权限，以实现这些功能所涉及的信息的收集和使用。请您注意，您开启这些权限即代表您授权我行可以收集和使用这些信息来实现上述功能，如您取消了这些授权，则我行将不再继续收集和使用您的这些信息，但同时也无法为您提供上述与这些授权所对应的功能。</p>
    <p>对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理信息。</p>
    <p>为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护我们、您或其他我们客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，我们可能会与银联、人民银行等监管机构或组织交换您的信息、服务信息及活动信息。不过,这并不代表我们会违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。</p>
    <p>若您未能按照与我们及我们其他用户签订的协议等法律文本的约定履行应尽义务，我们有权将上述信息写入黑名单，且与必要第三方进行数据共享。</p>
    <p class="weight">(二)转让</p>
    <p class="weight">我们不会将您的信息转让给任何公司、组织和个人，但以下情况除外:</p>
    <p class="weight">1、在获取明确同意的情况下转让:获得您的明确同意后，我们会向其他方转让您的信息;</p>
    <p class="weight">2、根据法律法规或强制性的行政或司法要求；</p>
    <p class="weight">3、在涉及合并、收购或破产清算时，如涉及到信息转让，我们会在要求新的持有您信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
    <p class="weight">(三)公开披露 </p>
    <p>我们仅会在以下情况下，公开披露您的信息:</p>
    <p>1、获得您明确同意后; </p>
    <p>2、基于法律的披露:在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的信息。</p>
    <p class="weight">四、我们如何保护和保存您的信息</p>
    <p>(一)我们已使用符合业界标准的安全防护措施保护您提供的信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的信息。例如，在您的浏览器与“服务”之间交换数据时受 SSL 加密保护;我们同时对平台网站提供 https 安全浏览方式;我们会使用加密技术确保数据的保密性;我们会使用受信赖的保护机制防止数据遭到恶意攻击;我们会部署访问控制机制，确保只有授权人员才可访问信息;以及我们会举办安全和隐私保护培训课程，加强员工对于保护信息重要性的认识。 </p>
    <p>(二)我们设立了个人信息保护责任部门信息安全领导小组，针对个人信息的处理开展个人信息安全影响评估，我们建立了相关安全管理制度、操作规范，对可能接触到您的信息的员工采取了最小授权原则，并与接触您个人信息的员工、合作机构签署保密协议，明确岗位职责及行为准则，同时对处理您的信息的员工所有操作行为进行系统审计。</p>
    <p>(三)为了保障您的信息安全，我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，通过网络层进行安全加密传输（TLS协议）、使用专用的网络通道、信息加密存储、严格的访问权限控制措施等 。</p>
    <p>(四)我们已获取的安全认证：我们先后获取公安部网络安全等级保护认证、支付卡行业数据安全标准认证，并与监管机构、第三方测评机构建立良好的沟通机制，及时抵御并处置各类信息安全威胁，为您的信息安全提供全方位保障。</p>
    <p>(五)我们的数据安全能力：对于我们所涉及的所有敏感信息进行去标识化处理，全部采用不可逆加密算法加密存储并进行异地备份，从数据传输到数据库存储，过程中全部加密保护。</p>
    <p>(六)请您务必妥善保管好您的账户及其他身份鉴别要素，互联网并非绝对安全的环境，我们强烈建议您不要通过互联网（如电子邮件、即时通讯工具等）明文传输您的个人账户信息、身份鉴别信息等，并请使用复杂密码，协助我们保证您的账号安全。一旦您泄漏了上述信息，您可能会蒙受损失，并可能产生对您不利的法律后果。如您发现账户登录名及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</p>
    <p>(七)我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。  我们将定期制定安全风险、个人信息安全影响评估等报告，及时总结阶段性工作，预防风险事件的发生。</p>
    <p>(八)互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担我们应承担的相应法律责任。</p>
    <p>(九) 我们已制定信息安全事件应急预案，并定期组织相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。除非法律法规、行业规范另有规定。</p>
    <p>(十)您在使用我们提供的产品及服务期间，我们将持续为您保存您的个人信息。在您注销帐户或主动删除相关信息后，您的个人信息将被我们保存至您的账号注销之日起五年，包括手机号、身份信息、实名认证信息、银行卡信息等。我们承诺这是为了保证您作为海科融通消费者的权益所必须的最短时间。</p>
    <p>同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。除非法律法规、行业规范另有规定，您的个人信息将被我们保存至您的账号注销之日起五年，包括手机号、身份信息、实名认证信息、银行卡信息等。我们承诺这是为了保证您作为海科融通消费者的权益所必须的最短时间。当您的个人信息超出该期限，我们会对您的个人信息进行删除或匿名化处理。</p>
    <p class="weight">五、您的权利 </p>
    <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的信息行使以下权利:</p>
    <p class="weight">(一)访问您的信息 </p>
    <p>您有权访问您的信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问:</p>
    <p>账户信息——如果您希望访问或编辑您的账户中的个人资料信息和支付结算信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过访问平台执行此类操作。</p>
    <p>搜索信息——您可以在平台中访问或清除您的搜索历史记录、查看和修改兴趣以及管理其他数据。 </p>
    <p>如果您无法通过上述链接访问这些信息，您可以随时使用我们的 Web 表单联系，或以文中的联系方式联系我们。 </p>
    <p>对于您在使用我们的产品或服务过程中产生的其他信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请以文中的联系方式联系我们。</p>
    <p class="weight">(二)更正您的信息 </p>
    <p>当您发现我们处理的关于您的信息有错误时，您有权要求我们做出更正。您可以联系我们提出更正申请。</p>
    <p>如果您无法通过上述链接更正这些信息，您可以随时使用我们的 Web 表单联系，或以文中联系方式联系我们。</p>
    <p>(三)删除您的个人信息 </p>
    <p class="weight">我们会根据您的操作及相关法律法规的要求进行删除处理。</p>
    <p class="weight">在以下情形中，您可以向我们提出删除个人信息的请求: </p>
    <p class="weight">1、如果我们处理信息的行为违反法律法规; </p>
    <p class="weight">2、如果我们收集、使用您的信息，却未征得您的同意;</p>
    <p class="weight">3、如果我们处理信息的行为违反了与您的约定; </p>
    <p class="weight">4、如果您不再使用我们的产品或服务，或您注销了账号;</p>
    <p class="weight">5、如果我们不再为您提供产品或服务。</p>
    <p>当您从我们的服务中删除个人信息后，我们可能不会立即从备份系统中删除相应的个人信息，但会在备份更新时删除这些信息，法律法规、行业规定保留的除外。</p>
    <p class="weight">(四)改变您授权同意的范围</p>
    <p>每个业务功能需要一些基本的信息才能得以完成(见本政策“第一部分”)。对于额外收集的信息的收集和使用，您可以随时给予或收回您的授权同意。当您取消信息收集和使用的授权后，我们将不再收集和使用该信息，但是法律规定或本政策约定的除外情形除外。</p>
    <p>当您收回同意后，我们将不再处理相应的信息。但您收回同意的决定，不会影响此前基于您的授权而开展的信息处理。</p>
    <p>如果您不想接受我们给您发送的商业广告，您随时可联系平台取消。</p>
    <p class="weight">(五)信息主体注销账户</p>
    <p>您可以通过我的->客服，点击拨打客服电话或发送电子邮件进行账户注销（电子邮件在下方）,您如果选择注销您的账户，在注销账户之后，我们将停止为您提供产品或服务，限期删除您的个人信息，法律法规、行业规范另有规定的除外。</p>
    <p class="weight">(六)约束信息系统自动决策</p>
    <p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</p>
    <p class="weight">(七)响应您的上述请求</p>
    <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
    <p>我们将在三十天内做出答复。如您不满意，还可以通过以下途径投诉: 客服电话400-668-6689，支付通客户端在线客服、支付通客服微信公共号、投诉邮箱kefu@hkrt.cn。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段(例如，需要开发新系统或从根本上改变现行惯例)、给他人合法权益带来风险或者非常不切实际(例如，涉及备份磁带上存放的信息)的请求，我们可能会予以拒绝。</p>
    <p class="weight">在以下情形中，按照法律法规要求，我们将无法响应您的请求:</p>
    <p class="weight">1、与个人信息控制者履行法律法规规定的义务相关的；</p>
    <p class="weight">2、与国家安全、国防安全直接相关的； </p>
    <p class="weight">3、与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p class="weight">4、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
    <p class="weight">5、有充分证据表明您存在主观恶意或滥用权利的；</p>
    <p class="weight">6、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人授权同意的；</p>
    <p class="weight">7、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
    <p class="weight">8、涉及商业秘密的；</p>
    <p class="weight">9、您的账户中存有未办结的业务，如账户还有余额或有债务未清偿。 </p>
    <p class="weight">六、我们如何处理未成年人的个人信息</p>
    <p>我们的产品、网站和服务主要面向已满18周岁的成年人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。</p>
    <p>对于经父母同意而收集未成年个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</p>
    <p>尽管法律和当地习俗对未成年人的定义不同，但我们将不满 18 周岁的自然人均视为未成年人。</p>
    <p>如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。 </p>
    <p>本条款不代表未成年人可以申请使用全部或部分海科融通的服务。</p>
    <p>七、您的信息如何在全球范围转移</p>
    <p>原则上，我们仅在中华人民共和国境内收集和产生的信息，将存储在中华人民共和国境内。如部分服务涉及跨境业务，我们需要向境外机构传输境内收集的个人信息的，我们会按照法律法规和相关监管部门的规定执行，向您说明个人信息出境的目的以及涉及的个人信息类型，征得您的同意，并通过签订协议、现场核查等有效措施，要求境外机构为所获取的您的个人信息保密。</p>
    <p class="weight">八、本政策如何更新</p>
    <p>我们的隐私政策可能变更。</p>
    <p>未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
    <p>对于重大变更，我们还会提供更为显著的通知(通知方式包括用户登录信息系统时、更新信息系统版本并在用户使用时弹出窗口、用户使用信息系统时直接向用户推送通知、向用户发送邮件、短信等)说明隐私政策的具体变更内容)。</p>
    <p class="weight">本政策所指的重大变更包括但不限于:</p>
    <p class="weight">1、我们的服务模式发生重大变化。如处理信息的目的、处理的信息类型、信息的使用方式等; </p>
    <p class="weight">2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、 破产并购等引起的所有者变更等; </p>
    <p class="weight">3、信息共享、转让或公开披露的主要对象发生变化;</p>
    <p class="weight">4、您参与信息处理方面的权利及其行使方式发生重大变化;</p>
    <p class="weight">5、我们负责处理信息安全的责任部门、联络方式及投诉渠道发生变化时; </p>
    <p class="weight">6、信息安全影响评估报告表明存在高风险时；</p>
    <p class="weight">7、其他可能对您的个人信息权益产生重大影响的变化。</p>
    <p>我们还会将本政策的旧版本存档，供您查阅。</p>
    <p>九、如何联系我们</p>
    <p>如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系: 客服电话400-668-6689，支付通客户端在线客服、支付通客服微信公共号、投诉邮箱kefu@hkrt.cn。我们设立了个人信息保护责任小组，竭尽全力保护您的个人信息，解决您的问题。如您对本隐私政策有任何疑问、意见或建议，亦可以通过邮箱grxxbh@hkrt.cn联系我们，一般情况下，我们将在三十天内回复。</p>
    <img src="../../assets/img/backPic.png" @click="back" class="pic" v-if="entryMode">
  </div>

</template>

<script>
  export default {
    data() {
      return {
        entryMode: "" //判断是怎么进来的
      }
    },
    created () {
      document.title = "隐私政策"
      let entryMode = this.$route.query.entryMode;//判断来源
      if(!!entryMode){
        this.entryMode = entryMode;
      }
    },
    methods: {
      back() {
        this.$router.push({
          name: "dzShare",
          query: {
            isBack: "0000"
          }
        })
      }
    },
  }
</script>

<style scoped>
  .wrap {
    padding: 0 10px;
  }

  .title {
    text-align: center;
    padding: 10px 0;
  }

  .weight {
    font-weight: bold;
  }

  p {
    line-height: 30px;
  }

  .subTitle {
    line-height: 28px;
    margin-top: 10px;
  }

  .pic {
    position: fixed;
    left: 0;
    bottom: 40%;
    opacity: .7;
  }

  table {
    width: 100%;
    border-spacing: 0;
  }

  .decor {
    text-decoration: underline;
  }
</style>